import React, { useMemo } from "react";

import AD_UNIT_300_250 from "../images/shackpet_banner_1.jpg";
import AD_LEFT_FULL_HEIGHT from "../images/left-banner.png";
import AD_RIGHT_FULL_HEIGHT from "../images/right-banner.png";

export default function AdBanner({ leftFullHeight, rightFullHeight }) {
	const bannerImage = useMemo(() => {
		if (leftFullHeight) {
			return AD_LEFT_FULL_HEIGHT;
		} else if (rightFullHeight) {
			return AD_RIGHT_FULL_HEIGHT;
		} else {
			return AD_UNIT_300_250;
		}
	}, [leftFullHeight, rightFullHeight]);

	return (
		<>
			<a
				className="banner-box"
				href="https://shackpets.page.link/Mg7K"
				target="_blank"
				rel="noopener noreferrer"
			>
				<img src={bannerImage} alt="banner" />
			</a>
		</>
	);
}
